import type {
  CalendarResponse,
  DuplicateCalendarSessionInput,
  DuplicateCalendarSessionResponse,
  MoveCalendarSessionInput,
  MoveCalendarSessionResponse,
  ReorderCalendarDayInput,
  ReorderCalendarDayResponse,
} from "@learn-flow/contracts";

import { apiRequest } from "../../lib/api.js";

export const calendarQueryRoot = ["calendar"] as const;

export function calendarQueryKey(startDate: string | null) {
  return [...calendarQueryRoot, startDate] as const;
}

export function loadCalendar(startDate: string | null): Promise<CalendarResponse> {
  const suffix = startDate ? `?startDate=${encodeURIComponent(startDate)}` : "";
  return apiRequest<CalendarResponse>(`/api/v1/calendar${suffix}`);
}

export function moveCalendarSession(
  sessionId: string,
  input: MoveCalendarSessionInput,
): Promise<MoveCalendarSessionResponse> {
  return apiRequest(`/api/v1/sessions/${sessionId}/move`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function reorderCalendarDay(
  scheduledDate: string,
  input: ReorderCalendarDayInput,
): Promise<ReorderCalendarDayResponse> {
  return apiRequest(`/api/v1/calendar/days/${encodeURIComponent(scheduledDate)}/order`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function duplicateCalendarSession(
  sessionId: string,
  input: DuplicateCalendarSessionInput,
): Promise<DuplicateCalendarSessionResponse> {
  return apiRequest(`/api/v1/sessions/${sessionId}/duplicate`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}
